import styled from 'styled-components/native';
import { dimensions } from '../../../styles';

export const SearchBarContainer = styled.View`
  padding-vertical: ${dimensions.halfMedium};
`;
